import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, Shield } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Logo } from "./Logo";
import { WalletButton } from "./WalletButton";
import { useApp } from "../context/AppContext";

const LINKS = [
  ["/", "Home"], ["/explore", "Explore Tokens"], ["/launch", "Launch Token"], ["/#competitions", "Competitions"], ["/liquidity", "Liquidity"],
  ["/listings", "Token Listings"], ["/leaderboard", "Leaderboard"], ["/community", "Community"], ["/portfolio", "Portfolio"],
];

const Item = ({ to, label, onClick, mobile }) => {
  const loc = useLocation();
  const onHome = loc.pathname === "/";
  const chat = to === "/#competitions";
  const forced = chat ? onHome && loc.hash === "#competitions" : to === "/" ? onHome && loc.hash !== "#competitions" : null;
  return (
  <NavLink to={to} end={to === "/"} onClick={(e) => { if (chat && onHome) document.getElementById("competitions")?.scrollIntoView({ behavior: "smooth" }); onClick?.(e); }} data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
    className={({ isActive: a }) => { const isActive = forced ?? a; return  `relative ${mobile ? `px-4 py-3 border-l-2 ${isActive ? "border-lime" : "border-transparent"}` : "px-3 py-2"} text-[13px] font-semibold tracking-wide transition-colors ${isActive ? "text-lime" : "text-slate-400 hover:text-slate-100"}`; }}>
    {({ isActive: a }) => { const isActive = forced ?? a; return (<>{label}{isActive && !mobile && <span className="absolute left-3 right-3 -bottom-[13px] h-[2px] bg-lime shadow-[0_0_12px_#39FF14]" />}</>); }}
  </NavLink>
  );
};

export const Navbar = () => {
  const { isAdmin } = useApp();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <header className="sticky top-0 z-50 border-b border-lime/15 bg-[#0A0C10]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1800px] items-center gap-4 px-4 lg:px-6">
        <Link to="/" data-testid="nav-logo"><Logo /></Link>
        <nav className="hidden xl:flex items-center ml-4">
          {LINKS.map(([to, l]) => <Item key={to} to={to} label={l} />)}
          {isAdmin && <Item to="/admin" label="Admin" />}
        </nav>
        <div className="ml-auto flex items-center gap-3">
          <Link to="/protocol" data-testid="nav-protocol" className="hidden md:flex items-center gap-1.5 text-[11px] font-mono text-slate-500 hover:text-lime">
            <Shield className="h-3.5 w-3.5" /> Protocol & contracts
          </Link>
          <WalletButton />
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="nav-mobile-menu" className="xl:hidden p-2 text-slate-300"><Menu className="h-5 w-5" /></button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#0A0C10] border-lime/20 w-72">
              <div className="mt-8 flex flex-col">
                {LINKS.map(([to, l]) => <Item key={to} to={to} label={l} mobile onClick={close} />)}
                {isAdmin && <Item to="/admin" label="Admin" mobile onClick={close} />}
                <Item to="/protocol" label="Protocol" mobile onClick={close} />
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export const Footer = () => (
  <footer className="border-t border-white/5 mt-16">
    <div className="mx-auto max-w-[1800px] px-6 py-8 flex flex-col md:flex-row gap-4 justify-between text-xs text-slate-500">
      <p data-testid="footer-disclaimer">
        HIVEVORA is an independent community interface on Robinhood Chain. Not affiliated with, sponsored or endorsed by Robinhood Markets, Inc. or Uniswap Labs.
        Swaps execute against Uniswap protocol contracts (v2/v3/v4) via the Uniswap Trading API or HIVEVORA's direct v3 router. Listings and placements are not audits or endorsements.
      </p>
      <p className="font-mono shrink-0">Chain 4663 · Testnet 46630</p>
    </div>
  </footer>
);
